import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapDirective } from './directives/map.directive';
import { AzMapLegendComponent } from './components/az-map-legend/az-map-legend.component';
import { AzMapSidebarComponent } from './components/az-map-sidebar/az-map-sidebar.component';
import { AzMapInfoButtonComponent } from './components/az-map-sidebar/az-map-info-button/az-map-info-button.component';
import { AzMapSettingsButtonComponent } from './components/az-map-sidebar/az-map-settings-button/az-map-settings-button.component';
import { AzMapZoomButtonsComponent } from './components/az-map-sidebar/az-map-zoom-buttons/az-map-zoom-buttons.component';
import { AzMapSettingRadioButtonComponent } from './components/az-map-sidebar/az-map-settings-button/az-map-setting-radio-button/az-map-setting-radio-button.component';
import { AzMapSettingToggleButtonComponent } from './components/az-map-sidebar/az-map-settings-button/az-map-setting-toggle-button/az-map-setting-toggle-button.component';
import { AzMapViewTypeSettingComponent } from './components/az-map-sidebar/az-map-settings-button/az-map-view-type-setting/az-map-view-type-setting.component';
import { PopupModule } from '@soti/popup';
import { PipesModule } from '@nx-fe/pipes';
import { TooltipModule } from '@soti/tooltip';
import { OverflowSpanModule } from '@nx-fe/overflow-span';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AzMapResetButtonComponent } from './components/az-map-sidebar/az-map-reset-button/az-map-reset-button.component';
import { StoreModule } from '@ngrx/store';
import { MapStyleEffects } from './core/store/map-style/map-style.effects';
import { EffectsModule } from '@ngrx/effects';
import { mapStyleReducer } from './core/store/map-style/map-style.reducers';
import { mapStyleFeatureKey } from './core/store/map-style/map-style.selectors';

@NgModule({
  declarations: [
    MapDirective,
    AzMapLegendComponent,
    AzMapSidebarComponent,
    AzMapInfoButtonComponent,
    AzMapSettingsButtonComponent,
    AzMapZoomButtonsComponent,
    AzMapSettingRadioButtonComponent,
    AzMapSettingToggleButtonComponent,
    AzMapViewTypeSettingComponent,
    AzMapResetButtonComponent,
  ],
  exports: [
    MapDirective,
    AzMapSidebarComponent,
    AzMapZoomButtonsComponent,
    AzMapResetButtonComponent,
    AzMapSettingsButtonComponent,
    AzMapViewTypeSettingComponent,
  ],
  imports: [
    CommonModule,
    PopupModule,
    PipesModule,
    TooltipModule,
    OverflowSpanModule,
    MatTooltipModule,
    StoreModule.forFeature(mapStyleFeatureKey, mapStyleReducer),
    EffectsModule.forFeature([MapStyleEffects]),
  ],
})
export class MapModule {
  constructor() {}
}
